import { jwtDecode } from "jwt-decode";

export const getDecodedToken = () => {
  const token = localStorage.getItem("token");
  if (!token) return null;

  try {
    const decoded = jwtDecode(token);
    if (decoded?.exp && decoded.exp * 1000 < Date.now()) {
      localStorage.removeItem("token");
      return null;
    }

    return decoded;
  } catch (error) {
    localStorage.removeItem("token");
    return null;
  }
};

export const hasAccess = (moduleName, userRoles) => {
  const moduleAccess = {
    "Admin Users": ["Master Admin", "Admin Users"],
    "Front Office": [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Principal",
      "Front Office",
    ],
    "Student Information": [
      "Master Admin",
      "Principal",
      "Admin",
      "Sub Admin",
      "Student Information",
    ],
    "Fees Collection": [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Fees Collection",
    ],
    "Behaviour Records": [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Principal",
      "Behaviour Records",
    ],
    Expenses: ["Master Admin", "Admin", "Expenses"],
    Attendance: [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Principal",
      "Attendance",
    ],
    "Human Resource": ["Master Admin", "Admin", "Human Resource", "Principal"],
    Library: ["Master Admin", "Admin", "Sub Admin", "Library", "Principal"],
    "Transport Management": [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Transport Management",
      "Principal",
    ],
    Examinations: [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Examinations",
      "Principal",
    ],
    Communicate: [
      "Master Admin",
      "Admin",
      "Sub Admin",
      "Communicate",
      "Principal",
    ],
    Homework: ["Master Admin", "Admin", "Sub Admin", "Principal", "Homework"],
    Inventory: ["Master Admin", "Admin", "Sub Admin", "Inventory"],
    Certificate: ["Master Admin", "Admin", "Sub Admin", "Certificate"],
    Reports: ["Master Admin", "Admin", "Sub Admin"],
    Website: ["Master Admin", "Admin", "Sub Admin", "Principal", "Website"],
    Vendor: ["Master Admin", "Admin", "Sub Admin"],
  };

  const allowedRoles =
    moduleAccess[moduleName]?.map((r) => r.toLowerCase().trim()) || [];
  return userRoles
    .map((r) => r.toLowerCase().trim())
    .some((role) => allowedRoles.includes(role));
};
